import $ from 'jquery'
import Spinner from '../ui/Spinner'

/**
 * @param {Object} config
 * @constructor
 */
export default function Applications(config) {
  $.extend(this, config || {})

  this.applications = config.applications
  this.client = config.client
  this.target = $('#application-container')
  this.nativeTarget = this.target.get(0)
  this.apis = ['draw', 'autoSearch', 'select', 'toolbar']
  this.activeApplication = null
  this.spinner = new Spinner()
  this.render()
  this.listeners = []
}

Applications.prototype.generateMenuItem = function(application) {
    const item = $(
        `<li><a role="menuitem" tabindex="-1" >${application.name}</a></li>`
    )

    return ({
        application,
        item
    })
}

Applications.prototype.stashApiListeners = function() {
    this.apis.forEach(a => {
        this.client.api[a].stashListeners()    
    })
}

Applications.prototype.popApiListeners = function() {
    this.apis.forEach(a => {
        this.client.api[a].popListeners()    
    })
}

Applications.prototype.startApplicationById = function(applicationId) {
    const application = this.applications.find(a => a.id === applicationId)
    if (application) {
        return this.startApplication(application)
    } else {
        return Promise.reject(new Error(`No application found with id ${applicationId}`))
    }
}

Applications.prototype.startApplication = function(application) {
    return application.start(this.client, this.nativeTarget).then(() => {
        this.triggerEvent({
            type: 'start',
            id: application.id,
            name: application.name
        })
    }).then(() => {
        this.activeApplication = application
        this.applicationsMenu.hide()
        this.quitButton.show()
        this.target.fadeIn()
        this.spinner.stop()
        this.applicationsMenu.toggleClass('open', false)
        this.client.api.draw.stashSource()
        this.stashApiListeners()
        this.client.api.toolbar.deactivateTool()
    })
}

Applications.prototype.stopApplication = function() {
  return this.activeApplication.stop(this.client, this.nativeTarget).then(() => {
        this.triggerEvent({
            type: 'stop',
            id: this.activeApplication.id,
            name: this.activeApplication.name
        })
    }).then(() => {
        this.target.empty()
        this.target.hide()
        this.applicationsMenu.show()
        this.quitButton.hide()
        this.activeApplication = null
        this.client.api.draw.popSource()
        this.popApiListeners()
        this.client.api.toolbar.deactivateTool()
    })
}

Applications.prototype.disable = function() {
    if (this.activeApplication) {
        return this.stopApplication().then(() => {
            this.applicationsMenu.hide()
        })
    } else {
        this.applicationsMenu.hide()
        return Promise.resolve()
    }
}

Applications.prototype.enable = function() {
    this.applicationsMenu.show()
}

Applications.prototype.render = function() {
    if (this.applications.length < 1) {
        return
    }
    const applicationButtons = $('.navbar-right ul:first')
    this.applicationsMenu = $('<li class="dropdown"></li>')

    this.quitButton = $(`
        <li><a><i class='fa fa-close'></i>Avsluta <span id='applicationName'></span></a></li>`)
        .hide()
        .appendTo(applicationButtons)
        .on('click', () => this.stopApplication())


    const title = $('<span>Applikationer</span>')
    const icon = $('<i class="fa fa-cubes"></i>')
    const caret = $(' <span class="caret"></span>')
    const link = $('<a class="dropdown-toggle" data-toggle="dropdown"></a>')
    link.appendTo(this.applicationsMenu)
    icon.appendTo(link)
    title.appendTo(link)
    caret.appendTo(link)

    const dropdown = $('<ul class="dropdown-menu" role="menu"></ul>')
    dropdown.appendTo(this.applicationsMenu)

    this.applications
        .map(this.generateMenuItem)
        .forEach(({application, item}) => {
            item.appendTo(dropdown)
            item.on('click', _ => {
                this.spinner.start()
                this.startApplication(application)
            })
        })

    link.on('click', () => {
        this.applicationsMenu.toggleClass('open')
    })

    this.applicationsMenu.appendTo(applicationButtons)

    $('#application-container').css({
        display: 'none',
        position: 'absolute',
        'z-index': 1099
    })
}

/**
 * Create an event trigger
 * @return {function} trigger function to handle changes in applications
 */
Applications.prototype.triggerEvent = function(e) {
    this.listeners
        .filter(l => l.type.toLowerCase() === e.type.toLowerCase())
        .forEach(l => l.callback(e))
}
/**
 * Add event listener
 * @param {string} type event type
 * @return {function} listener callback function
 * @memberof! module:api/Applications#
 * @api
 */
Applications.prototype.on = function(type, callback) {
    this.listeners.push({
        type: type,
        callback: callback
    })
}
/**
 * Remove event listener
 * @param {string} type event type
 * @return {function} listener callback function
 * @memberof! module:api/Applications#
 * @api
 */
Applications.prototype.un = function(type, callback) {
    this.listeners = this.listeners.filter(
        listener => listener.type !== type || listener.callback !== callback
    )
}
